// bp 14/12/2020: consider to remove pathname because when adding new pathname, this function will miss cover
export const checkIsOwner = (data, userId) => {
  if (data?.type === 'member') return true;
  if (data?.hasOwnProperty('isOwner')) {
    return data?.isOwner;
  }
  return userId === data?.ownerId;
};

export const checkIsAwgProduct = (ownerId) =>
  ownerId === parseInt(process.env.REACT_APP_AWG_ID);

export const checkIsDollarProduct = (ownerId) =>
  ownerId === parseInt(process.env.REACT_APP_DOLLAR_GENERAL_ID);

export const checkIsLowesProduct = (ownerId) =>
  ownerId === parseInt(process.env.REACT_APP_LOWES_ID);

export const allowDemoMemberUseEvalForm = (ownerId) => {
  let allowMemberId = process.env.REACT_APP_ALLOW_EVAL_MEM_ID;
  if (!allowMemberId) return false; // no allow member Id will return false

  let allowMembers = allowMemberId.split(',').map((x) => +x);

  return allowMembers.includes(ownerId);
};

export const allowMemberUseEvalForm = (ownerId) => {
  return checkIsAwgProduct(ownerId) || allowDemoMemberUseEvalForm(ownerId);
};
